import { useEffect, useCallback, useState } from 'react';
import { languageMap } from '../../maps/languageMap';
import { useActions, useScanner, useTypedSelector } from '../../hooks';
import { NavigationButton } from '../common';
import { Modal } from 'react-bootstrap';

const ScannerHelper = () => {
  const [scannerNeedsAuth, setTicketNeedsAuth] = useState(false);
  const [scannerConnected, setTicketConnected] = useState(false);
  const [setScanner] = useScanner();
  const { updateSettingUpScanners } = useActions();
  const language = useTypedSelector(({ session }) => {
    return session.language;
  });
  const logger = useTypedSelector(({ devices }) => {
    return devices.logger;
  });
  const scanner = useTypedSelector(({ devices }) => {
    return devices.scanner;
  });
  useEffect(() => {
    if (logger) {
      setScanner(logger);
    }
  }, [logger]);
  useEffect(() => {
    if (scanner) {
      connectScanner();
    }
  }, [scanner]);
  useEffect(() => {
    if (scannerConnected) {
      console.log('Finished setting up scanners!');
      updateSettingUpScanners(false);
    }
  }, [scannerConnected, updateSettingUpScanners]);
  const connectScanner = async () => {
    if (scanner && !scanner.isConnected()) {
      addScannerEventListeners();
      await scanner?.connectAsync().catch((error) => {
        logger?.error(error);
      });
    }
  };
  //#region Scanner Event Listeners
  const addScannerEventListeners = () => {
    scanner?.addEventListener('connection', onScannerConnected);
    scanner?.addEventListener('disconnection', onScannerDisconnected);
    scanner?.addEventListener('authorization', onScannerNeedsAuth);
  };
  const removeScannerEventListeners = () => {
    scanner?.removeEventListener('connection', onScannerConnected);
    scanner?.removeEventListener('disconnection', onScannerDisconnected);
    scanner?.removeEventListener('authorization', onScannerNeedsAuth);
  };
  const onScannerConnected = useCallback(() => {
    console.log('scanner tickets se ha conectado');
    setTicketConnected(true);
  }, []);
  const onScannerDisconnected = useCallback(() => {
    console.log('scanner tickets se ha desconectado');
    setTicketConnected(false);
  }, []);
  const onScannerNeedsAuth = useCallback(() => {
    console.log('scanner tickets necesita Auth');
    setTicketNeedsAuth(true);
  }, []);
  //#endregion
  const renderFooter = (detector: string) => {
    return (
      <Modal.Footer>
        <div className="email-modal-button">
          <NavigationButton
            buttonContent={languageMap.scanner_helper.auth_button[language]}
            buttonClass="navigation-button confirm-button complete"
            onClickButton={() => {
              if (detector === 'tickets') {
                scanner?.authorizeAsync();
                setTicketNeedsAuth(false);
              }
            }}
          />
        </div>
        <div className="email-modal-button"></div>
      </Modal.Footer>
    );
  };
  return (
    <>
      <Modal
        show={scannerNeedsAuth}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {languageMap.scanner_helper.auth_message[language]} guías
          </Modal.Title>
        </Modal.Header>
        {renderFooter('tickets')}
      </Modal>
    </>
  );
};

export { ScannerHelper };
